import { sortArray } from "../../../../services/array-helpers";
import { formatCurrency, formatDate, formatNumber } from "../../../../services/format";
import { GetLiquidCustomers } from "../../../../services/requests";
import { downloadReport, resendInvoice, reverseBilling } from "../../../../services/requests/billing/liquid-billing-requests";
import { FormItemType } from "../../../UI/view/component-map";
import { Repository } from "../../../UI/view/data-source";
import { FormView } from "../../../UI/view/form-view";
import { createView } from "../../../UI/view/view";
import { billingPermissions } from "../billing-datasource";
import { bulkItemEditGrid } from "./liquid-bulk-line-items";
import { LiquidBillingInvoiceDataSource } from "./liquid-invoice-list";
import { RecentDeliveriesList } from "./liquid-recent-deliveries";
import { UnlinkedCreditInvoicesFieldLinker } from "./liquid-invoice-list-unlinked";
import { BsLink45Deg } from "react-icons/bs";
import { infoPane } from "./liquid-invoice-edit-infopane";

export const footer = [
  {
    type: FormItemType.row,
    items: [
      {
        type: FormItemType.button,
        variant: 'danger',
        style: { marginLeft: 2 },
        label: 'Backout...',
        fitToContent: true,
        hideIf: ({ watch }) => {
          const jdeBatchNumber = watch('jdebatchNumber');
          return !jdeBatchNumber;
        },
        handler: async ({ watch, confirm, loadEntity }) => {
          const reversable = watch('reversable')
          let confirmed = false;
          if (reversable) {
            confirmed = await confirm('This invoice has yet to be processed by JDE. By performing this action you will completely reverse this invoice.')
          } else {
            confirmed = await confirm('This invoice has already been processed by JDE. This action will only undo changes within VTS. Please verify the necessary steps have been performed in JDE to reverse this invoice.')
          }
          if (confirmed) {
            const success = await reverseBilling({ billingId: watch('billingId') });
            alert('Invoice has been backed out successfully.');
            loadEntity();
          }

        }
      },
      {
        type: FormItemType.button,
        label: 'Resend',
        hideIf: ({ watch }) => {
          const jdeBatchNumber = watch('jdebatchNumber');
          return !jdeBatchNumber;
        },
        handler: async ({ watch, confirm, methods }) => {
          const confirmed = await confirm('Are you sure you want to resend this invoice?')
          if (confirmed) {
            const success = await resendInvoice({ billingId: watch('billingId') });
            await confirm('Invoice has been resent.', true);
            methods.loadEntity();
          }
        }
      },
      {
        type: FormItemType.button,
        label: 'Preview',
        handler: ({ watch }) => {
          window.open(`https://vts.linde.grp/Helium/VTS/NewReports/LiquidFillSheet.aspx?trkno=${watch('trackingNumberId')}`, '_blank');
        }
      },
      {
        type: FormItemType.button,
        label: 'Print',
        handler: ({ watch }) => {
          const root = `http://${process.env.REACT_APP_RPT}/ReportServer`;
          window.open(`${root}/Pages/ReportViewer.aspx?%2fBulk+Helium+Reports%2fBulk_Billing_Summary&rs:Command=Render&billingid=${watch('billingId')}`, '_blank');
        }
      },
      {
        type: FormItemType.button,
        label: 'Print Supplemental Docs',
        fitToContent: true,
        handler: ({ watch }) => {
          const root = `http://${process.env.REACT_APP_RPT}/ReportServer`;
          window.open(`${root}/Pages/ReportViewer.aspx?%2fBulk+Helium+Reports%2fBulk_Billing_Summary_Supplimental&rs:Command=Render&billingid=${watch('billingId')}`, '_blank');
        }
      },
      {
        type: FormItemType.button,
        variant: 'secondary',
        label: 'Download',
        handler: async ({ getValues }) => {
          const { billingId, customerId } = getValues();
          if (customerId == "92403579") {
            downloadReport({ filename: `LHe Customs Invoice #${billingId}A.pdf`, billingId });
          } else {
            downloadReport({ filename: `Liquid Helium Invoice_lx${billingId}.pdf`, billingId });
          }
        }
      },
    ]
  },
  {
    type: FormItemType.button,
    style: { marginLeft: 'auto' },
    label: 'Update',
    variant: 'primary',
    handler: async ({ methods, handleSubmit, onSubmit, redirect, confirm }) => {
      const { setValue } = methods;
      let isError = false;
      let result = null;
      let errorMessage = '';
      try {
        result = await handleSubmit(onSubmit)();
      } catch (e) {
        isError = true;
        errorMessage = e.message || 'An unknown error occurred.';
      }
      if (isError) {
        await confirm(`${errorMessage}`, true);
      }
    }
  },

];

export const liquidInvoiceEdit = {
  editMode: true,
  pageHeader: 'Liquid Billing',
  permissions: billingPermissions,
  breadcrumbs: [
    {
      name: 'Liquid Billing',
      icon: 'currency-dollar',
      to: '/billing/liquidproduct',
    },
  ],
  items: [
    {
      type: FormItemType.masterDetailLayout,
      items: [
        {
          items: [
            {
              type: FormItemType.infoPane,
              autoHide: false,
              header: ({ liquidbilling }) => liquidbilling?.current?.data?.customerName,
              infoListItems: infoPane
            },
            {
              type: FormItemType.fileAttachments,
              entityTypeId: 13,
              entityName: 'Attachments',
              permissions: billingPermissions,
            },
          ]
        },

        {
          type: FormItemType.tab,
          items: [
            {
              label: 'Liquid Billing',
              items: [
                {
                  type: FormItemType.fieldset,
                  label: 'Billing Information',
                  items: [
                    {
                      type: FormItemType.row,
                      items: [
                        {
                          type: FormItemType.select,
                          label: 'Customer',
                          name: 'customerId',
                          disabled: () => true,
                          minWidth: 200,
                          options: async () => {
                            const customers = sortArray({ data: (await GetLiquidCustomers(null)), key: 'customerName', sortingOrder: 'asc' });
                            return [{ text: "", id: null }, ...customers.map(c => ({ id: c.customerId, text: c.customerName }))]
                          }
                        },
                        {
                          name: 'socpo',
                          label: 'SO #',
                          minWidth: 200,
                        },
                        {
                          name: 'customerPort',
                          label: 'Customer Port',
                          minWidth: 200,
                        },
                        {
                          name: 'containerIdstarted',
                          label: 'Container',
                          disabled: () => true,
                          minWidth: 200,
                        },
                      ]
                    },
                    {
                      type: FormItemType.row,
                      items: [
                        {
                          name: 'dateStarted',
                          label: 'Date',
                          type: FormItemType.date,
                          minWidth: 200,
                        },
                        {
                          name: 'sailDate',
                          label: 'Sailing Date',
                          type: FormItemType.date,
                          minWidth: 200,
                        },
                        {
                          label: 'Override Gross Weight (lbs)',
                          name: 'overrideGrossWeight',
                          number: true,
                          minWidth: 200,
                        },
                        {
                          label: 'Override Net Product Weight (lbs)',
                          name: 'overrideNetProductWeight',
                          number: true,
                          minWidth: 200,
                        },
                      ]
                    },
                    {
                      type: FormItemType.row,
                      items: [
                        {
                          label: 'Override Order ID',
                          name: 'overrideOrderId',
                          minWidth: 200,
                        },
                        {
                          label: 'Override Invoice Date',
                          name: 'overrideInvoiceDate',
                          type: FormItemType.date,
                          minWidth: 200,
                        },
                        {
                          label: 'PO #',
                          name: 'ponumber',
                          minWidth: 200,
                        },
                        {
                          label: 'RO #',
                          name: 'roNumber',
                          minWidth: 200,
                        },
                      ]
                    },
                    {
                      type: FormItemType.row,
                      items: [


                        {
                          label: 'Vessel',
                          name: 'vessel',
                          minWidth: 200,
                        },
                        {
                          label: 'Override Terms of Sale',
                          name: 'invoiceTermsOverride',
                          minWidth: 200,
                        },
                        {
                          label: 'Routed Transaction',
                          name: 'routedTransaction',
                          type: FormItemType.checkboxField,
                          defaultValue: false,
                          minWidth: 200,
                        },
                        {
                          label: 'Related Party',
                          name: 'relatedParty',
                          type: FormItemType.checkboxField,
                          defaultValue: false,
                          minWidth: 200,
                        },
                      ]
                    },

                    {
                      type: FormItemType.row,
                      items: [
                        {
                          label: 'Container',
                          name: 'containerIdstarted',
                          type: FormItemType.labelField
                        },
                        {
                          label: 'Billing Notes',
                          name: 'billingComments',
                          type: FormItemType.labelField,
                          style: { color: 'red', fontWeight: 'bold' }

                        },
                        {
                          label: 'Order Type',
                          name: 'orderTypeName',
                          type: FormItemType.labelField
                        },
                        {
                          label: 'Hold Bill',
                          name: 'isHold',
                          type: FormItemType.checkboxField,
                          minWidth: 200,
                        }
                      ]
                    },

                    {
                      type: FormItemType.row,
                      items: [
                        {
                          label: 'Tracking #',
                          name: 'trackingNumberId',
                          type: FormItemType.labelField,
                          link: ({ watch }) => {
                            const isStaging = watch('isStagingInvoice');
                            const jdeVolume = watch('jdeVolume');
                            const stagingType = watch('stagingType') ?? '';
                            const trackingNumberId = watch('trackingNumberId');
                            if (isStaging) {
                              return `https://vts.linde.grp/Helium/VTS/Liquid/StagingInventory.aspx?trkno=${trackingNumberId}&StagingType=${stagingType}`;
                            } else {
                              if (jdeVolume > 0) {
                                return `https://vts.linde.grp/Helium/VTS/Liquid/Shipping.aspx?trkno=${trackingNumberId}`;
                              }
                              return `https://vts.linde.grp/Helium/VTS/Liquid/Inventory.aspx?trkno=${trackingNumberId}`;
                            }
                            //
                          },
                        },
                        {
                          label: 'Booking Id',
                          name: 'bookingId',
                          type: FormItemType.labelField,
                          link: ({ watch }) => watch('bookingId') ? `https://vts.linde.grp/Helium/VTS/Logistics/Bookings_Edit.aspx?bookingid=${watch('bookingId')}` : null,
                        },
                        {
                          label: 'Booking Agent',
                          name: 'bookingAgent',
                          type: FormItemType.labelField,
                        },
                        {
                          label: 'Default Terms',
                          name: 'invoiceTermsOfSale',
                          type: FormItemType.labelField,
                        }
                      ]
                    },
                    {
                      name: 'customerComments',
                      label: 'Customer Comments',
                      type: FormItemType.textarea,
                    },
                    {
                      name: 'deliveryComments',
                      label: 'Delivery Comments',
                      type: FormItemType.textarea,
                    },
                    {
                      name: 'approvalComments',
                      label: 'Approval Comments',
                      type: FormItemType.textarea,
                    },
                    {
                      name: 'fillSheetComments',
                      label: 'Fillsheet Comments',
                      type: FormItemType.labelField,
                      computedValue: (getValues, editTableProps, watch) => {
                        const { isStagingInvoice, liquidTrackingNumber, stagingInventory } = getValues();
                        if (isStagingInvoice) {
                          return stagingInventory?.comments ?? '';
                        }
                        return liquidTrackingNumber?.comments ?? '';
                      }
                    },
                    {
                      name: 'liquidTrackingNumber.liquidFilling.order.otherNotes',
                      label: 'Order Comments',
                      type: FormItemType.labelField,
                    },
                    {
                      label: 'Bypass Invoice',
                      name: 'jdebypassed',
                      type: FormItemType.checkboxField,
                      width: 140,
                      fitToContent: true,
                      hideIf: ({ watch }) => watch('jdebatchNumber')
                    },
                    {
                      name: 'isStagingInvoice',
                      hideIf: () => true
                    },
                    {
                      name: 'billingId',
                      hideIf: () => true
                    },
                    {
                      name: 'isStockTransfer',
                      hideIf: () => true
                    }
                  ]
                },

              ],
              footerItems: footer
            },
            {
              label: 'Bulk Line Items',
              items: [
                {
                  type: FormItemType.fieldset,
                  label: 'Bulk Line Items',
                  items: [
                    bulkItemEditGrid
                  ]
                }
              ],
              footerItems: footer
            },
            {
              label: 'Recent Deliveries',
              items: [
                {
                  type: FormItemType.customField,
                  name: 'recentDeliveries',
                  component: RecentDeliveriesList
                }
              ]
            },
            {
              label: 'Link Credit',
              hide: (state: any) => !(state.liquidbilling?.current?.data?.liquidCustomer?.linkCreditDebit ?? false),
              badgeIcon: (state, formState) => {
                const linkedCreditInvoiceId = formState.watch('linkedCreditInvoiceId');
                return linkedCreditInvoiceId ? BsLink45Deg : null;
              },
              items: [
                {
                  type: FormItemType.fieldset,
                  label: 'Link Credit Invoice',
                  items: [
                    {
                      type: FormItemType.infoPane,
                      style: { marginBottom: 2 },
                      variant: 'borderless',
                      hide: ({ watch }) => !watch('linkedCreditInvoiceId'),
                      infoListItems: [
                        {
                          name: 'linkedCreditInvoiceId',
                          label: 'Linked Credit Invoice',
                          isLink: true,
                          value: ({ linkedCreditInvoiceId }) => {
                            return `/billing/liquidedit/${linkedCreditInvoiceId}`;
                          }
                        },
                        {
                          name: 'linkedCreditAffectsInboundFreight',
                          label: 'Affects Inbound Freight',
                          value: ({ linkedCreditAffectsInboundFreight }) => {
                            return linkedCreditAffectsInboundFreight ? 'Yes' : 'No';
                          }
                        },
                        {
                          name: 'linkedCreditVolume',
                          label: 'Linked Credit Volume',
                          value: ({ linkedCreditVolume }) => {
                            return linkedCreditVolume ? linkedCreditVolume.toString() : 'N/A';
                          }
                        },
                        {
                          name: 'linkedCreditAmount',
                          label: 'Linked Credit Amount',
                          value: ({ linkedCreditAmount }) => {
                            return linkedCreditAmount ? linkedCreditAmount.toString() : 'N/A';
                          }
                        },
                        {
                          name: 'linkedCooldownTemp',
                          label: 'Linked Cooldown Temp',
                          value: ({ linkedCooldownTemp }) => {
                            return linkedCooldownTemp ? linkedCooldownTemp.toString() : 'N/A';
                          }
                        }
                      ]
                    },

                    {
                      type: FormItemType.customField,
                      style: { height: '100%', paddingBottom: 20, marginTop: 15 },
                      /*                   required: true, */
                      name: 'creditInvoiceIdToLink',
                      label: 'Unlinked Credit Invoices',
                      component: UnlinkedCreditInvoicesFieldLinker,
                    },
                  ]
                }
              ]
            },
            {
              label: 'Audit Logs',
              unMountOnExit: true,
              items: [
                {
                  type: FormItemType.auditLogs,
                  name: 'BillingHeaders',
                  tableSchema: 'Billing'
                }
              ]
            },
            {
              label: 'General Info',
              items: [
                {
                  width: 400,
                  items: [
                    {
                      type: FormItemType.infoPane,
                      autoHide: false,
                      autoGrow: true,
                      header: ({ liquidbilling }) => liquidbilling?.current?.data?.customerName,
                      infoListItems: infoPane
                    },
                  ]
                }

              ]
            }
          ]
        }
      ]
    }
  ]
} as FormView;


export const LiquidInvoiceEdit = createView({ form: liquidInvoiceEdit, repository: LiquidBillingInvoiceDataSource as Repository });